export default "__VITE_ASSET__DrE8GAcY__"